import React from 'react';
import Highlighter from 'react-highlight-words';

import { stripHtml } from '../../utils/string';

function Item(props) {
  const escapedText = stripHtml(props.item.description) || '';
  const showImage =
    props.item.images && props.item.images.medium
      ? props.item.images.medium
      : props.item.images && props.item.images.thumbnail
      ? props.item.images.thumbnail
      : props.item.imageUrl;

  return (
    <div className='search-item' style={props.style} onClick={props.onClick}>
      {showImage && <img src={showImage} alt='show' />}
      <div className='search-item-title'>{props.item.title}</div>
      {props.item.description && (
        <div className='search-item-description'>
          <Highlighter
            activeIndex={-1}
            highlightClassName='search-item-highlight'
            searchWords={props.searchWords || []}
            autoEscape={false}
            caseSensitive={false}
            textToHighlight={escapedText}
          />
        </div>
      )}
    </div>
  );
}

export default Item;
